<template>
  <!-- 员工属性组基本资料 -->
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText v-model="list.staff_property_group_name"
                               :isNational="judegNational('staff_property_group_name')"
                               :error-messages="
                $errors('list', 'staff_property_group_name', requiredRule.concat(nocharacter))
              "
                               :readonly="readonly"
                               :label="$t('label_staff_property_group_name') + '*'"></mrc_ess_multiText>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText v-model="list.staff_property_group_code"
                               :error-messages="
                $errors('list', 'staff_property_group_code', requiredRule.concat(nocharacter))
              "
                               :isNational="judegNational('staff_property_group_code')"
                               :readonly="readonly"
                               :label="$t('label_staff_property_group_code') + '*'"></mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText v-model="list.staff_property_group_description"
                               noRequired
                               :error-messages="
                $errors('list', 'staff_property_group_description', nocharacter)
              "
                               :isNational="judegNational('staff_property_group_description')"
                               :readonly="readonly"
                               :label="$t('label_description')"></mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText textarea
                               noRequired
                               :error-messages="
                $errors('list', 'remarks', nocharacter)
              "
                               v-model="list.remarks"
                               :isNational="judegNational('remarks')"
                               :readonly="readonly"
                               :label="$t('label_note')"></mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         v-if="!readonly"
                         @cancel="cancel"
                         :successText="
          !$store.state.uuid ? $t('label_The_next_step') : $t('label_submit')
        ">
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
import {
  getStaffPropertyGroupDetail,
  getPropertyGroupDetail,
  deleteStaffPropertyGroup,
  updateStaffPropertyGroup,
  addStaffPropertyGroup,
  getAddList,
} from '@/service/api/staffPropertyGroup.js'
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
    },
  },
  validations: {
    list: {
      staff_property_group_name: {
        required, nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      staff_property_group_description: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      staff_property_group_code: {
        required, nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      remarks: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
    },
  },
  data () {
    return {
      skeletonloading: true,
      list: {
        staff_property_group_name: '', //属性分组名称
        staff_property_group_description: '', //属性分组描述
        staff_property_group_code: '', //属性分组编码
        is_default: 0, //是否默认
        org_level_uuid: '', //所属公司
        remarks: '', //备注
      },
    }
  },
  created () { },
  async mounted () {
    this.national('mrbase_sys_staff_property_group')
    if (this.$store.state.uuid) {
      await this.getdetail()
    }
  },
  methods: {
    async getdetail () {
      //获取整个列表
      this.skeletonloading = true
      const uuid = this.$store.state.uuid
      const res = await getStaffPropertyGroupDetail({
        uuid: this.$store.state.uuid,
      })
      this.list = res.data
      this.skeletonloading = false
    },
    async success () {
      //详情修改提交按钮
      if (this.$store.state.uuid) {
        this.deleteLanguageCode(this.list.staff_property_group_name)
        this.deleteLanguageCode(this.list.staff_property_group_description)
        this.deleteLanguageCode(this.list.remarks)
        this.list.mrbase_sys_staff_property_group_default_value = []
        const res = await updateStaffPropertyGroup({ ...this.list })
        if (res.code == 200) {
          this.$Message({ text: this.$t('message_The_modification_was_successful') })
          await this.getdetail()
          this.$emit('changereadonly')
        }
      }
      else {
        this.$v.list.$touch()
        if (this.$v.list.$error) return
        const org_level_uuid = this.$store.state.currentCompany
        this.list.org_level_uuid = org_level_uuid
        this.$emit('next', 2, this.list)
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getdetail()
        this.$emit('changereadonly')
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit')
        }).then(res => {
          this.$router.push({
            name: 'staffPropertyGroup',
          })
        }).catch(err => { })
      }
    },
    deleteLanguageCode (arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach(item => {
          delete item.language_code
        })
      }
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped></style>
